import { DataBean } from "../DataBean";

export class TotalControlNationalizationCustomBondedWarehouse extends DataBean {


    public async getTotalControlNationalizationCustomBondedWarehouseCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getTotalControlNationalizationCustomBondedWarehouseCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }


 
}